module.exports = __webpack_public_path__ + "img/xujun.9a12e818.png";